export type SearchCondition =
    'IsNull' |
    'IsNotNull' |
    'Equal' |
    'NotEqual' |
    'Less' |
    'LessEqual' |
    'Greater' |
    'GreaterEqual' |
    'Like' |
    'NotLike' |
    'Regexp'

export const SearchConditionDescription: Record<SearchCondition, string> = {
    IsNull: "없음",
    IsNotNull: "있음",
    Equal: "일치",
    NotEqual: "불일치",
    Less: "보다 작음",
    LessEqual: "보다 작거나 같음",
    Greater: "보다 큼",
    GreaterEqual: "보다 크거나 같음",
    Like: "포함",
    NotLike: "포함하지 않음",
    Regexp: "정규표현식"
}

export const SearchConditionValuePrerequisite: Record<SearchCondition, boolean> = {
    IsNull: false,
    IsNotNull: false,
    Equal: true,
    NotEqual: true,
    Less: true,
    LessEqual: true,
    Greater: true,
    GreaterEqual: true,
    Like: true,
    NotLike: true,
    Regexp: true,
}